<template>
    <div class="tw-animate-pulse">
        <div class="tw-aspect-[19/34] tw-bg-gray-300"></div>
        <div class="tw-mt-2 tw-h-4 tw-w-3/4 tw-bg-gray-300 tw-mx-auto tw-rounded-lg"></div>
    </div>
</template>

<script setup lang="ts">

</script>

<style scoped>

</style>
